<template>
  <div>
    <v-toolbar flat color="white" pt-5 mt-5>
      <v-btn round color="primary" @click="addItem()">Add Canned Response</v-btn>
      <v-spacer></v-spacer>
      <v-text-field v-model="search" label="Search"></v-text-field>
    </v-toolbar>
    <v-data-table
      :loading="load"
      :headers="headers"
      class="elevation-1"
      :items="cannedResponses"
      item-key="id"
      :search="search"
      align-center
      style="cursor: pointer"
    >
      <template v-slot:items="props">
        <td class="text-xs-center">
            <v-icon @click="editItem(props.item)">edit</v-icon>
          <v-icon @click="deleteItem(props.item)">delete</v-icon>
        </td>
        <td  class="text-xs-center">{{props.item.name}}</td>
        <td  class="text-xs-center">{{props.item.message}}</td>
      </template>
      <template
        v-slot:pageText="props"
      >Records {{ props.pageStart }} - {{ props.pageStop }} of {{ props.itemsLength }}</template>
    </v-data-table>

    <v-dialog v-model="addCannedResponse" max-width="750px">
      <v-card flat color="white">
        <v-toolbar color="primary">
          <h1 class="headline white--text">Add Canned Response</h1>
        </v-toolbar>
        <v-card-text>
          <v-text-field label="Name" v-model="item.name"></v-text-field>

          <v-textarea label="Message" v-model="item.message"></v-textarea>
        </v-card-text>
        <v-card-actions>
          <v-layout justify-center>
            <v-btn round color="primary" @click="addCannedResponse=false, item={}">Cancel</v-btn>
            <v-btn round color="primary" v-if="item.name" @click="saveCannedResponse">Save</v-btn>
            <v-btn round color="primary" v-else disabled>Save</v-btn>
          </v-layout>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="editCannedResponse" max-width="750px">
      <v-card flat color="white">
        <v-toolbar color="primary">
          <h1 class="headline white--text">Edit Canned Response</h1>
        </v-toolbar>
        <v-card-text>
          <v-text-field label="Name" v-model="item.name"></v-text-field>
          <v-textarea label="Message" v-model="item.message"></v-textarea>
        </v-card-text>
        <v-card-actions>
          <v-layout justify-center>
            <v-btn round color="primary" @click="editCannedResponse=false, item={}">Cancel</v-btn>
            <v-btn round color="primary" v-if="item.name" @click="saveEditedCannedResponse">Save</v-btn>
            <v-btn round color="primary" v-else disabled>Save</v-btn>
          </v-layout>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Api from "@/services/Api";
export default {
  data() {
    return {
      load:true,
      cannedResponses:[],
      addCannedResponse: false,
      editCannedResponse: false,
      search: '',
      item: {},
      headers: [
        {
          text: "Action",
          align: "center",
          sortable: false
        },
        {
          text: "Name",
          align: "center",
          value: "name"
        },
        {
          text: "Message",
          align: "center",
          value: "message"
        }
      ]
    };
  },
  created(){
    this.fetchCannedResponses()
  },
  methods: {
      editItem(item) {
        if(this.authUpdate(this.$store.state.currentRoute)){
      this.item = Object.assign({}, item);
      this.editCannedResponse = true;
      }
    },
    deleteItem(item) {
        if(this.authDelete(this.$store.state.currentRoute)){
      confirm("Are you sure you would like to delete this canned response?") &&
        Api()
          .put("/cannedResponse/" + item.id, {
            isActive: false,
            isDeleted: true
          })
          .then(response=>{
              this.fetchCannedResponses()
          });
        }
    },
    addItem(){
        if(this.authCreate(this.$store.state.currentRoute)){
            this.addCannedResponse=true
        }
    },
    saveCannedResponse() {
      Api()
        .post("/cannedResponse", {
          name: this.item.name,
          message: this.item.message,
          isActive: true,
          isDelete: false
        })
        .then(response => {
          this.addCannedResponse = false
          this.item = {}
          this.fetchCannedResponses()
        });
    },
    saveEditedCannedResponse() {
      Api()
        .put("/cannedResponse/"+this.item.id, {
          name: this.item.name,
          message: this.item.message,
          isActive: true,
          isDelete: false
        })
        .then(response => {
          this.editCannedResponse = false
          this.item = {}
          this.fetchCannedResponses()
        });
    },
    fetchCannedResponses(){
      this.load=true
         Api()
        .get("/cannedResponses")
        .then(response => {
          this.cannedResponses = response.data
          this.load=false
        });
    }
  }
};
</script>

<style>
</style>